import { ApiService } from "../../../services/ApiService";
import {
  GET_PERFORMANCE_REVIEW,
  GET_EVENT,
  GET_EMPLOYEE_APPARAISAL,
  VIEW_EMPLOYEE_APPARAISAL,
} from "../../actionTypes";

export class performanceMngtThunk {
  static getPerformanceReview() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(
          "events/check-performance-review"
        );
        if (response.data) {
          dispatch({
            type: GET_PERFORMANCE_REVIEW,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getEvents() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("events/");
        if (response.data) {
          dispatch({
            type: GET_EVENT,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getEmployeeAppraisal() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(`events/employees`);
        console.log("es", response);
        if (response.data) {
          dispatch({
            type: GET_EMPLOYEE_APPARAISAL,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static viewEmployeeApparaisal(id) {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(
          `events/view-employee-appraisal/`
        );
        if (response.data) {
          dispatch({
            type: VIEW_EMPLOYEE_APPARAISAL,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/performancemanagement/performance.thunk.js